import * as types from '../actions/actionTypes'
import * as loadMoreReducerHelper from '../libs/loadMoreReducerHelper'

export const initialState = {
  slashInfo: null, // from requestGetInflowHistories 1st fetch
  list: loadMoreReducerHelper.createInitialState(), // requestGetInflowHistories result
  transactions: {}, // key = transactionId, value = requestGetInflowHistoryDetail result
}

/*
  slashInfo example: {
    total_amount: 5001,
    available_amount: 5001,
    exchange_rate: 31,
  }
 */

export default function inflowHistoryReducer(
  inflowHistory = initialState,
  action,
) {
  const { list, slashInfo } = inflowHistory
  const { payload } = action
  switch (action.type) {
    case types.GET_INFLOW_HISTORIES:
      return {
        ...inflowHistory,
        list: loadMoreReducerHelper.onStartFetching(list),
      }
    case types.GET_INFLOW_HISTORIES_SUCCESS:
      return {
        ...inflowHistory,
        slashInfo: payload.slashInfo ?? slashInfo,
        list: loadMoreReducerHelper.onFetchSuccess(
          list,
          payload.records,
          payload.replace,
        ),
      }
    // * outflow API also returns slash info
    case types.GET_OUTFLOW_HISTORIES_SUCCESS:
      return {
        ...inflowHistory,
        slashInfo: payload.slashInfo ?? slashInfo,
      }
    case types.GET_INFLOW_HISTORIES_ERROR:
      return {
        ...inflowHistory,
        list: loadMoreReducerHelper.onFetchError(list),
      }
    case types.GET_INFLOW_HISTORY_DETAIL_SUCCESS: {
      const { transactionId } = payload
      return {
        ...inflowHistory,
        transactions: {
          [transactionId]: payload.data,
        },
      }
    }
    case types.GET_INFLOW_HISTORY_DETAIL_ERROR:
      return {
        ...inflowHistory,
        transactions: {
          [payload.transactionId]: null,
        },
      }
    case types.MAKE_WITHDRAW_SUCCESS:
      // * substract withdraw value
      if (slashInfo) {
        return {
          ...inflowHistory,
          slashInfo: {
            ...slashInfo,
            available_amount: slashInfo.available_amount - payload.amount,
          },
        }
      }
      return inflowHistory
    default:
      return inflowHistory
  }
}
